/**
 * Customer names for the Our Customers desktop hero grid (Figma 6323-30291).
 *
 * Each name is stored on a `SquareVM` instance inside
 * `public/assets-next/our-customers/our-customers-hero-desktop.riv`.
 * `autoBind: true` on the Rive runtime applies those instance values to the
 * bound `SquareTexts` components (replacing the editor placeholder "text").
 */
export const OUR_CUSTOMERS_HERO_GRID_NAMES = [
  "Seed Golf",
  "3Bears",
  "Perfect Ted",
  "True Classic",
  "Happy Nuts",
  "Powerlete",
  "Correxiko",
  "Kekoa Foods",
  "Hopr",
  "Ghost Golf",
] as const;

export type OurCustomersHeroGridName =
  (typeof OUR_CUSTOMERS_HERO_GRID_NAMES)[number];

/** SquareVM instance index → name (from the .riv export). */
export const OUR_CUSTOMERS_HERO_SQUARE_VM_NAMES: Record<number, string> = {
  1: "Seed Golf",
  2: "Perfect Ted",
  3: "Powerlete",
  4: "Happy Nuts",
  8: "True Classic",
  10: "3Bears",
  12: "Common Cents",
  28: "Seed Golf",
  31: "3Bears",
  42: "Perfect Ted",
  44: "Common Cents",
  48: "True Classic",
  55: "Happy Nuts",
  57: "Powerlete",
  61: "Correxiko",
  65: "Kekoa Foods",
  67: "Hopr",
};

export const SQUARE_VM_NAME = "SquareVM";
export const SQUARE_VM_STRING_PROPERTY = "stringProperty";
